export default __webpack_public_path__ + "static/media/eye-icon.0853b62f.svg";